import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReceivedEmail } from '../../../models/email-message';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { Store } from '@ngxs/store';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { DatePipe, NgIf } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { PanelModule } from 'primeng/panel';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-received-email-list',
  standalone: true,
  imports: [ButtonModule, TableModule, NgIf, TagModule, DatePipe, PanelModule, DialogModule],
  templateUrl: './received-email-list.component.html',
  styleUrl: './received-email-list.component.scss'
})
export class ReceivedEmailListComponent
{
  @Input() emails?: ReceivedEmail[] = [];
  @Output() emailViewed = new EventEmitter<ReceivedEmail>();

  viewEmailVisible: boolean = false;
  selectedViewEmail: ReceivedEmail | null = null;

  constructor() {}

  openViewEmail(email: ReceivedEmail): void {
    this.selectedViewEmail = email;
    this.viewEmailVisible = true;
    this.emailViewed.emit(email);
  }

  get sortedEmails() : ReceivedEmail[]
  {
    if (!this.emails) {
      return [];
    }

    return [...this.emails].sort((a, b) => new Date(b.dateReceived).valueOf() - new Date(a.dateReceived).valueOf());
  }

}
